import { useState, useRef } from "react";
import "./editorialForms.css";

export default function LibraryForm({ data, onChange }) {
  const coverImageInputRef = useRef(null);

  const handleCoverImageChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      const reader = new FileReader();
      reader.onloadend = () => {
        onChange({
          ...data,
          coverImage: file,
          coverImageName: file.name,
          coverImagePreview: reader.result,
        });
      };
      reader.readAsDataURL(file);
    }
  };
  const categories = [
    "Ficcao",
    "Nao-Ficcao",
    "Negocios",
    "Tecnologia",
    "Autoajuda",
    "Biografia",
    "Historia",
    "Ciencia",
    "Arte",
    "Filosofia",
    "Religiao",
    "Educacao",
    "Infantil",
    "Romance",
    "Fantasia",
    "Terror",
    "Poesia",
  ];

  const languages = [
    { id: "pt", name: "Portugues" },
    { id: "en", name: "Ingles" },
    { id: "es", name: "Espanhol" },
    { id: "fr", name: "Frances" },
    { id: "de", name: "Alemao" },
    { id: "it", name: "Italiano" },
  ];

  const availabilities = [
    { id: "available", name: "Disponivel" },
    { id: "borrowed", name: "Emprestado" },
    { id: "reserved", name: "Reservado" },
  ];

  return (
    <div className="editorial_form library_form">
      <div className="editorial_form_section">
        <label>
          Capa do Livro (opcional)
        </label>
        <div className="file_upload_area" onClick={() => coverImageInputRef.current?.click()}>
          <input
            ref={coverImageInputRef}
            type="file"
            accept="image/*,.jpg,.jpeg,.png,.webp"
            onChange={handleCoverImageChange}
            style={{ display: "none" }}
          />
          {data?.coverImagePreview ? (
            <div className="file_selected sticker_preview">
              <img src={data.coverImagePreview} alt="Capa" style={{ maxWidth: "100px", maxHeight: "160px", borderRadius: "8px" }} />
              <button
                type="button"
                onClick={(e) => {
                  e.stopPropagation();
                  onChange({ ...data, coverImage: null, coverImageName: null, coverImagePreview: null });
                }}
                className="file_remove_btn"
              >
                ✕
              </button>
            </div>
          ) : (
            <div className="file_placeholder">
              <svg viewBox="0 0 24 24" fill="currentColor" width="32" height="32">
                <path d="M21 19V5c0-1.1-.9-2-2-2H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2zM8.5 13.5l2.5 3.01L14.5 12l4.5 6H5l3.5-4.5z" />
              </svg>
              <p>Clique para fazer upload da capa</p>
              <span>JPG, PNG, WEBP</span>
            </div>
          )}
        </div>
      </div>

      <div className="editorial_form_section">
        <label>
          Titulo do Livro <span className="required">*</span>
        </label>
        <input
          type="text"
          placeholder="Ex: O Senhor dos Aneis"
          value={data?.title || ""}
          onChange={(e) => onChange({ ...data, title: e.target.value })}
        />
      </div>

      <div className="editorial_form_section">
        <label>
          Autor <span className="required">*</span>
        </label>
        <input
          type="text"
          placeholder="Ex: J.R.R. Tolkien"
          value={data?.author || ""}
          onChange={(e) => onChange({ ...data, author: e.target.value })}
        />
      </div>

      <div className="editorial_form_section">
        <label>Descricao</label>
        <textarea
          placeholder="Sinopse ou descricao do livro..."
          value={data?.description || ""}
          onChange={(e) => onChange({ ...data, description: e.target.value })}
          maxLength={2000}
          rows={3}
        />
      </div>

      <div className="editorial_form_row">
        <div className="editorial_form_section">
          <label>ISBN</label>
          <input
            type="text"
            placeholder="978-3-16-148410-0"
            value={data?.isbn || ""}
            onChange={(e) => onChange({ ...data, isbn: e.target.value })}
          />
        </div>

        <div className="editorial_form_section">
          <label>Numero de Paginas</label>
          <input
            type="number"
            placeholder="Ex: 350"
            value={data?.pageCount || ""}
            onChange={(e) =>
              onChange({ ...data, pageCount: parseInt(e.target.value) || 0 })
            }
          />
        </div>
      </div>

      <div className="editorial_form_section">
        <label>Categoria</label>
        <select
          value={data?.category || ""}
          onChange={(e) => onChange({ ...data, category: e.target.value })}
        >
          <option value="">Selecione</option>
          {categories.map((cat) => (
            <option key={cat} value={cat}>
              {cat}
            </option>
          ))}
        </select>
      </div>

      <div className="editorial_form_row">
        <div className="editorial_form_section">
          <label>Idioma</label>
          <select
            value={data?.language || "pt"}
            onChange={(e) => onChange({ ...data, language: e.target.value })}
          >
            {languages.map((lang) => (
              <option key={lang.id} value={lang.id}>
                {lang.name}
              </option>
            ))}
          </select>
        </div>

        <div className="editorial_form_section">
          <label>Ano de Publicacao</label>
          <input
            type="number"
            placeholder="Ex: 1954"
            value={data?.publishedYear || ""}
            onChange={(e) =>
              onChange({
                ...data,
                publishedYear: parseInt(e.target.value) || 0,
              })
            }
          />
        </div>
      </div>

      <div className="editorial_form_section">
        <label>Editora</label>
        <input
          type="text"
          placeholder="Nome da editora"
          value={data?.publisher || ""}
          onChange={(e) => onChange({ ...data, publisher: e.target.value })}
        />
      </div>

      <div className="editorial_form_row">
        <div className="editorial_form_section">
          <label>Avaliacao (0-5)</label>
          <input
            type="number"
            min="0"
            max="5"
            step="0.5"
            placeholder="4.5"
            value={data?.rating || ""}
            onChange={(e) =>
              onChange({ ...data, rating: parseFloat(e.target.value) || 0 })
            }
          />
        </div>

        <div className="editorial_form_section">
          <label>Disponibilidade</label>
          <select
            value={data?.availability || "available"}
            onChange={(e) => onChange({ ...data, availability: e.target.value })}
          >
            {availabilities.map((avail) => (
              <option key={avail.id} value={avail.id}>
                {avail.name}
              </option>
            ))}
          </select>
        </div>
      </div>

      <div className="editorial_form_tip library_tip">
        <svg viewBox="0 0 24 24" fill="currentColor" width="16" height="16">
          <path d="M18 2H6c-1.1 0-2 .9-2 2v16c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zM6 4h5v8l-2.5-1.5L6 12V4z" />
        </svg>
        <span>
          Adicione livros a sua biblioteca pessoal ou compartilhada. Outros
          usuarios poderao ver e solicitar emprestimo.
        </span>
      </div>
    </div>
  );
}
